import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DashboardButton from '../DashboardButton';
import SidebarGroup from 'App/components/SidebarGroup';
import hasLength from 'App/utils/hasLength';

const propTypes = {
    dashboardGroups: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            dashboards: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                    title: PropTypes.string.isRequired,
                })
            ),
        })
    ).isRequired,
};

const defaultProps = {};

function TherigyDashboardList({ dashboardGroups }) {
    const groups = useMemo(() => {
        return dashboardGroups.filter((group) => {
            return hasLength(group.dashboards);
        });
    }, [dashboardGroups]);

    return (
        <>
            {groups.map((section) => {
                const stateKey = `insights-sidebar-${section.name}-${section.id}`;
                return (
                    <SidebarGroup key={section.id} headerText={section.name} stateKey={stateKey}>
                        <ul className="button-list">
                            {section.dashboards.map((dash) => {
                                return (
                                    <li key={dash.id}>
                                        <DashboardButton dash={dash} />
                                    </li>
                                );
                            })}
                        </ul>
                    </SidebarGroup>
                );
            })}
        </>
    );
}

TherigyDashboardList.propTypes = propTypes;
TherigyDashboardList.defaultProps = defaultProps;

export default TherigyDashboardList;
